import { useEffect, useRef, useState } from "react";
import { FaHome } from "react-icons/fa";
import { GoLocation } from "react-icons/go";
import { HiOutlineSearch } from "react-icons/hi";
import { TbGridDots } from "react-icons/tb";
import { TfiAngleDown } from "react-icons/tfi";
import { Link } from "react-router-dom";
import { dropdownData } from "../../data/navbar/dropdown";
import Container from "./Container";
import Dropdwon from "./Dropdwon";
import List from "./List";
import Listitem from "./Listitem";
import NavCategory from "./NavCategory";

const Navbar = () => {
  const [catDropDown, setCatDropDown] = useState(false);
  const [bedFordDropDwon, setBedFordDropDown] = useState(false);
  const catRef = useRef();
  const bedRef = useRef();

  useEffect(() => {
    document.body.addEventListener("click", (e) => {
      if (catRef.current.contains(e.target)) {
        setCatDropDown(true);
      } else {
        setCatDropDown(false);
      }
      if (bedRef.current.contains(e.target)) {
        setBedFordDropDown(true);
      } else {
        setBedFordDropDown(false);
      }
    });
  }, []);
  return (
    <nav>
      <div className="mt-4 w-full bg-primary py-6">
        <Container>
          <div className=" flex items-center justify-between ">
            <div className=" flex items-center gap-x-3">
              <div className="cursor-pointer rounded-md bg-white py-3.5 px-3">
                <Link to="/">
                  <FaHome className="h-5 w-5 text-primary" />
                </Link>
              </div>
              <div className="relative flex items-center">
                <div className="flex items-center rounded-l-lg bg-[#F4F4F4] py-3 px-3">
                  <TbGridDots className="h-6 w-6 text-primary" />
                  <Dropdwon
                    dropRef={catRef}
                    className="relative flex cursor-pointer items-center gap-x-3"
                  >
                    <p className="font-regular test-sm flex font-pop text-textColor ">
                      Category
                    </p>
                    <TfiAngleDown className="flex h-3 w-3 " />
                    {catDropDown && <NavCategory dropdownData={dropdownData} />}
                  </Dropdwon>
                </div>
                <input
                  className="font-regular test-sm w-[295px] py-3 px-4 font-pop text-[#818181]"
                  type="text"
                  placeholder="What are you looking for?"
                />
                <div className="flex items-center border-l border-darkGreen border-opacity-20 bg-white py-3 px-3">
                  <GoLocation className="h-4 w-4 text-primary" />
                  <Dropdwon
                    dropRef={bedRef}
                    className="flex cursor-pointer items-center gap-x-3"
                  >
                    <p className="font-regular test-sm flex font-pop text-textColor ">
                      Bedfordview
                    </p>
                    <TfiAngleDown className="flex h-3 w-3 " />
                    {bedFordDropDwon && (
                      <List className="absolute top-12 right-[63px] bg-white">
                        <Listitem
                          className="border-b border-solid border-darkGreen border-opacity-20 py-2 px-10"
                          itemname="Bedfordview"
                        />
                        <Listitem
                          className="border-b border-solid border-darkGreen border-opacity-20 py-2 px-10"
                          itemname="Bedfordview"
                        />
                        <Listitem
                          className="border-b border-solid border-darkGreen border-opacity-20 py-2 px-10"
                          itemname="Bedfordview"
                        />
                        <Listitem
                          className="border-b border-solid border-darkGreen border-opacity-20 py-2 px-10"
                          itemname="Bedfordview"
                        />
                        <Listitem
                          className="border-b border-solid border-darkGreen border-opacity-20 py-2 px-10"
                          itemname="Bedfordview"
                        />
                      </List>
                    )}
                  </Dropdwon>
                </div>
                <button
                  className="w-[63px] cursor-pointer rounded-r-lg border-2 border-solid border-white bg-primary py-2.5 px-5"
                  type=""
                >
                  <HiOutlineSearch className="h-6 w-6 text-white" />
                </button>
              </div>
            </div>
            <div className=" flex items-center">
              <div className=" flex items-center gap-x-2">
                <button className="test-sm rounded-md bg-white py-3.5 px-5 font-pop font-medium text-textColor">
                  Latest Listings
                </button>
                <button className="test-sm rounded-md bg-white py-3.5 px-4 font-pop font-medium text-textColor">
                  Ending soon
                </button>
                <Link to="/business-listing">
                  <button className="test-sm rounded-md bg-white py-3.5 px-5 font-pop font-medium text-textColor">
                    Buisness Listings
                  </button>
                </Link>
                <div>
                  <Link to="/create-auctionlist-form">
                    <img
                      className=" h-12 w-[104px] cursor-pointer"
                      src="/assets/images/buttonnav.png"
                      alt="sell button"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </nav>
  );
};

export default Navbar;
